export const PLAYLIST_DURATION = {
	1: [3, 5, 10, 15, 20, 30, 45, 60, 75, 90], // minutes for SoulCycle
	2: [3, 5, 10, 15, 20, 30, 45, 60, 75, 90], // minutes for Equinox
	3: [5, 10, 15, 20, 30, 45, 60], // minutes for Rumble Boxing
	4: [5, 10, 15, 20, 30, 45, 60, 90], // minutes for SolidCore
	5: [5, 10, 15, 20, 30, 45, 60, 90], // minutes for Precsion Run
};
